import {
	SYNCHRONIZE_ACCESSPOINT_FAILURE,
	SYNCHRONIZE_ACCESSPOINT_REQUEST,
	SYNCHRONIZE_ACCESSPOINT_SUCCESS,
	SYNCHRONIZE_ACCESSPOINT_USER_FAILURE,
	SYNCHRONIZE_ACCESSPOINT_USER_REQUEST,
	SYNCHRONIZE_ACCESSPOINT_USER_SUCCESS,
	SYNCHRONIZE_SCHEDULES_FAILURE,
	SYNCHRONIZE_SCHEDULES_REQUEST,
	SYNCHRONIZE_SCHEDULES_SUCCESS,
	SYNCHRONIZE_USER_FAILURE,
	SYNCHRONIZE_USER_REQUEST,
	SYNCHRONIZE_USER_SUCCESS,
} from "./synchronizeAccessPoint&UserConstant";

export const synchronizeAccessPointAndUserReducer = (
	initialState = {
		syncAccessPointAndUsers: [],
	},
	action
) => {
	switch (action.type) {

		case SYNCHRONIZE_ACCESSPOINT_USER_REQUEST:
			return { ...initialState, getSyncLoading: true };
		case SYNCHRONIZE_ACCESSPOINT_USER_SUCCESS:
			return {
				...initialState,
				getSyncLoading: false,
				syncAccessPointAndUsers: action?.payload?.data?.result || [],
			};
		case SYNCHRONIZE_ACCESSPOINT_USER_FAILURE:
			return {
				...initialState,
				getSyncLoading: false,
				getSyncError: action.payload,
			};

		case SYNCHRONIZE_ACCESSPOINT_REQUEST:
			return { ...initialState, syncAccessPointLoading: true };
		case SYNCHRONIZE_ACCESSPOINT_SUCCESS:
			return {
				...initialState,
				syncAccessPointLoading: false,
			};
		case SYNCHRONIZE_ACCESSPOINT_FAILURE:
			return {
				...initialState,
				syncAccessPointLoading: false,
				syncAccessPointError: action.payload,
			};

		case SYNCHRONIZE_USER_REQUEST:
			return { ...initialState, syncUserLoading: true };
		case SYNCHRONIZE_USER_SUCCESS:
			return {
				...initialState,
				syncUserLoading: false,
				syncUserSuccess: true,
			};
		case SYNCHRONIZE_USER_FAILURE:
			return {
				...initialState,
				syncUserLoading: false,
				syncUserError: action.payload,
			};

			case SYNCHRONIZE_SCHEDULES_REQUEST:
			return { ...initialState, syncSchedulesLoading: true };
		case SYNCHRONIZE_SCHEDULES_SUCCESS:
			return {
				...initialState,
				syncSchedulesLoading: false,
				syncSchedulesSuccess: true,
			};
		case SYNCHRONIZE_SCHEDULES_FAILURE:
			return {
				...initialState,
				syncSchedulesLoading: false,
				syncSchedulesError: action.payload,
			};

		default:
			return initialState;
	}
};
